import { IMAGE_TYPE, POLL_TYPE, RICOS_POLL_TYPE } from '@wix/ricos';
export const PLUGIN_CONFIG_DEFAULTS = (internalProps) => ({
    mention: {},
    [IMAGE_TYPE]: {},
});
export const PLUGIN_CONFIG_OVERRIDES = (internalProps) => ({});
export const DISABLED_PLUGIN_TYPES_FOR_GUESTS = [POLL_TYPE, RICOS_POLL_TYPE];
//# sourceMappingURL=plugins.js.map